import { Skeleton } from './Skeleton';
import { SkeletonRegion } from './SkeletonRegion';

interface CardGridSkeletonProps {
  label: string;
  cards?: number;
  /** Label/value lines per card. */
  lines?: number;
}

/** A grid of summary cards (heading, action, label/value lines) — the approval-ladder shape. Stacks to one column on phones. */
export function CardGridSkeleton({ label, cards = 4, lines = 3 }: CardGridSkeletonProps) {
  return (
    <SkeletonRegion label={label} className="grid gap-4 sm:grid-cols-2">
      {Array.from({ length: cards }, (_, card) => (
        <div key={card} className="rounded-lg border border-line bg-surface p-6">
          <div className="mb-5 flex items-center justify-between gap-3">
            <Skeleton className="h-4 w-40" />
            <Skeleton className="h-6 w-24" />
          </div>
          <div className="flex flex-col gap-3">
            {Array.from({ length: lines }, (_, line) => (
              <div key={line} className="flex justify-between gap-3">
                <Skeleton className="h-4 w-28" />
                <Skeleton className="h-4 w-20" />
              </div>
            ))}
          </div>
        </div>
      ))}
    </SkeletonRegion>
  );
}
